var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    rx: 2.301167,
    width: 15,
    x: 2.5,
    y: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 8.33333333h-1.94444167c-.30682639 0-.55555833.24873194-.55555833.55555834v4.44444163h10v-4.44444163c0-.3068264-.2487319-.55555834-.5555583-.55555834h-1.9444417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 13.3333364v-5.54166973c0-.34126055.17402987-.65895983.46160833-.84269167l1.5-.95833333c.3282872-.20974036.74849617-.20974036 1.07678337 0l1.5.95833333c.2875784.18373184.4616083.50143112.4616083.84269167v5.54166973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 11.666667v1.666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.99983333 8.29166667c-.02286654.00017442-.0412869.01880674-.04119969.04167379s.01864915.04135833.04151636.04135833c.0228672 0 .0414292-.01849128.0415164-.04135833s-.0183332-.04149937-.0411997-.04167379z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanSchool);
export default __webpack_public_path__ + "static/media/loan-school.442f7db9c90d74a8e00fa856955772d0.svg";
export { ForwardRef as ReactComponent };